import data from './data'

let product_list = []

let types = Array.from(new Set(data.map(item => item.type)))
types.forEach(x => {
    const product_type_list = {
        type: x.replace(/(\s?)TOP \d+/, ''),
        list: [],
				title: ""
    }
    data.forEach(y => {
        if (x === y.type) {
					product_type_list.title = y.dir
					product_type_list.list.push({
                product_name: y.product_name,
                desc: y.desc,
                dir: y.dir,
                width_pc: y.width_pc,
								shop_url: y.url
            })
        }
    })
	product_list.push(product_type_list)
})
export default product_list

